export const GET_ALL_FEATURES= 'GET_ALL_FEATURES';
export const LOAD_FEATURES_LOADING= 'LOAD_FEATURES_LOADING';
export const LOAD_FEATURES_ERROR= 'LOAD_FEATURES_ERROR';



